import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export const useOrgSettings = (orgId) => {
  const [settings, setSettings] = useState({ orgName: '', logoUrl: '' });

  useEffect(() => {
    if (!orgId) return;
    const unsub = onSnapshot(doc(db, 'orgs', orgId, '_config', 'settings'), (snap) => {
      if (snap.exists()) setSettings(snap.data());
    });
    return unsub;
  }, [orgId]);

  return settings;
};
